var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "instillinger",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.944 8.784C13.976 8.528 14 8.272 14 8C14 7.728 13.976 7.472 13.944 7.216L15.632 5.896C15.784 5.776 15.824 5.56 15.728 5.384L14.128 2.616C14.032 2.44 13.816 2.376 13.64 2.44L11.648 3.24C11.232 2.92 10.784 2.656 10.296 2.456L9.99202 0.336C9.96802 0.144 9.80002 0 9.60002 0H6.40002C6.20002 0 6.03202 0.144 6.00802 0.336L5.70402 2.456C5.21602 2.656 4.76802 2.928 4.35202 3.24L2.36002 2.44C2.17602 2.368 1.96802 2.44 1.87202 2.616L0.272018 5.384C0.168018 5.56 0.216018 5.776 0.368018 5.896L2.05602 7.216C2.02402 7.472 2.00002 7.736 2.00002 8C2.00002 8.264 2.02402 8.528 2.05602 8.784L0.368018 10.104C0.216018 10.224 0.176018 10.44 0.272018 10.616L1.87202 13.384C1.96802 13.56 2.18402 13.624 2.36002 13.56L4.35202 12.76C4.76802 13.08 5.21602 13.344 5.70402 13.544L6.00802 15.664C6.03202 15.856 6.20002 16 6.40002 16H9.60002C9.80002 16 9.96802 15.856 9.99202 15.664L10.296 13.544C10.784 13.344 11.232 13.072 11.648 12.76L13.64 13.56C13.824 13.632 14.032 13.56 14.128 13.384L15.728 10.616C15.824 10.44 15.784 10.224 15.632 10.104L13.944 8.784ZM8.00002 10.8C6.45602 10.8 5.20002 9.544 5.20002 8C5.20002 6.456 6.45602 5.2 8.00002 5.2C9.54402 5.2 10.8 6.456 10.8 8C10.8 9.544 9.54402 10.8 8.00002 10.8Z",
    fill: "#70707F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2f330bee.svg";
export { ForwardRef as ReactComponent };